import $ from 'jquery';
import loadScript from './loader';
import isTouch from '../exports/touch-detect';

export default async function productNativeVideo(uniqueKey) {
  const $player = $(`[data-player="${uniqueKey}"]`);
  const $playerElement = $player.find('video');
  const videoLoad = {
    name: 'video-ui',
    version: '1.0',
  };
  await loadScript(videoLoad);

  const player = new window.Shopify.Plyr($playerElement[0]);
  $player.on('pause', function() {
    if (player.pause) { player.pause(); }
  });
  $player.on('play-desktop', function() {
    if (player.play && !isTouch()) { $player.trigger('play'); }
  });
  $player.on('play', function() {
    try {
      if (player.play) {
        player.play();
      } else {
        player.addEventListener('onReady', function(event) {
          event.target.play();
        });
      }
    } catch (e) {
      console.warn(e);
    }
  });
  $player.on('destroy', function() {
    try {
      if (player.destroy) {
        player.destroy();
      }
    } catch (e) {
      console.warn(e);
    }
  });
  return player;
}
